export default __webpack_public_path__ + "static/media/discover.18d3ee88.svg";